import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {IFilterQueryCDR} from '../core/_models'
import {enableMapSet} from 'immer'

enableMapSet()
export interface CDRFilterState {
  query?: IFilterQueryCDR
}

const initialState: CDRFilterState = {query: {offset: 0, limit: 10}}

const cdrFilterSlice = createSlice({
  name: 'cdrFilter',
  initialState: initialState,
  reducers: {
    updateQuery(state, action: PayloadAction<Partial<IFilterQueryCDR>>) {
      const payload = action.payload
      const shouldResetOffset = payload.offset === undefined && payload.limit === undefined
      state.query = {
        ...state.query,
        ...payload,
        ...(shouldResetOffset ? {offset: 0} : {}),
      }
    },

    setQuery(state, action: PayloadAction<IFilterQueryCDR>) {
      state.query = action.payload
    },

    resetQuery(state) {
      state.query = {
        ...state.query,
        offset: 0,
        rules: undefined,
      }
    },

    resetLlmRules(state) {
      state.query = {
        ...state.query,
        rules_llm: null,
      }
    },
  },
})

export const {resetQuery, setQuery, updateQuery, resetLlmRules} = cdrFilterSlice.actions
export default cdrFilterSlice.reducer
